import React from 'react';

import NumberField from '../Molecules/NumberField';
import SingleNextButton from '../Atoms/SingleNextButton';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import { getApp} from '../../index';
import { ssnRegex, dateRegex } from '../../Utils/ValidationPatterns';

class StepExtendedIdentity extends React.Component {

    render() {

        var rFirstName = getApp('fname');
        var firstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);

        return (
            <StepShell stepID="StepExtendedIdentity"
                friendlyText={`Hello ${firstName}! Now we need a few details to verify your identity.`}
                requestText=""
                progress="30%"
                backLink="/loan-application/identity"
                progressLabel="Verification"
            >
                <Form nextLink="/loan-application/address">
                    <NumberField name="dob" label="Date of Birth (e.g. 09/09/1999)" format="##/##/####" required={true} pattern={dateRegex} />
                    <div className="hug">
                        <span className="dob-message error-message">You need to be 18 or older in order to submit this application</span>
                    </div>
                    <NumberField  name="ssn" label="Social Security Number" encName="prim_enc" encrypt={true} format="###-##-####" required={true} pattern={ssnRegex} />
                    <SingleNextButton nextBtnTxt="next" />
                </Form>
            </StepShell>
        )
    }
}

export default StepExtendedIdentity;